import { useTranslation } from "react-i18next";
import {
  VOUCHER_PROVIDER_AMAZON, VOUCHER_PROVIDER_FREE,
  VOUCHER_PROVIDER_MOBILITY,
  VOUCHER_PROVIDER_PLATFORM,
} from "../../../component/Constants";

export const useVoucherProviders = () => {

  const { t } = useTranslation(["salesmarketing"], { keyPrefix: "voucher" });

  const providersValues = [
    {
      value: VOUCHER_PROVIDER_AMAZON,
      label: t("providersValues.amazon"),
    },
    {
      value: VOUCHER_PROVIDER_PLATFORM,
      label: t("providersValues.platform"),
    },
    {
      value: VOUCHER_PROVIDER_MOBILITY,
      label: t("providersValues.mobility"),
    },
    {
      value: VOUCHER_PROVIDER_FREE,
      label: t("providersValues.free"),
    },

  ];

  return {
    providersValues,
  };
};
